import { render, staticRenderFns } from "./KnInterfaceColorThemeListItem.vue?vue&type=template&id=5d8c721c&scoped=true"
import script from "./KnInterfaceColorThemeListItem.js?vue&type=script&lang=js&external"
export * from "./KnInterfaceColorThemeListItem.js?vue&type=script&lang=js&external"
import style0 from "./KnInterfaceColorThemeListItem.vue?vue&type=style&index=0&id=5d8c721c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c721c",
  null
  
)

export default component.exports